<template>
  <component :is="packageComponent()" :config="config" />
</template>

<script>
import DefaultValue from './DefaultValue.vue'
export default {
  extends: DefaultValue,
  components: {
    //
  },
  methods: {
    packageComponent() {
      let packageName = _.pascalCase(this.action.value)
      if (!this.$options.components?.[`ActionPackage${packageName}`]) {
        this.$options.components[`ActionPackage${packageName}`] = this.$util.requireOrNull(`/views/Automation/Modal/Actions/Values/Packages/${packageName}Package.vue`) || this.$util.requireOrNull(`/views/Automation/Modal/Actions/Values/Packages/DefaultPackage.vue`)
      }
      return packageName ? `ActionPackage${packageName}` : null
    }
  }
}
</script>
